import { render, staticRenderFns } from "./SectionEditor.vue?vue&type=template&id=4ab2d930&scoped=true&lang=pug"
import script from "./SectionEditor.vue?vue&type=script&lang=js"
export * from "./SectionEditor.vue?vue&type=script&lang=js"
import style0 from "./SectionEditor.vue?vue&type=style&index=0&id=4ab2d930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab2d930",
  null
  
)

export default component.exports